import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsCancelNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M28.768 5l-1.767-1.768-11 11-11-11L3.231 5l11 11-11 11.001L5 28.769l11-11 11 11L28.77 27l-11-11z"
        fill=""
      />
    </svg>
  )
);
SvgActionsCancelNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsCancelNormalMedium;
